import type { ApiParams, AptiRequestConfig } from "@/lib/types/api";
import type {
  Assessment,
  AssessmentSubmissionBody,
  AssessmentSubmissionResponse,
  Task,
} from "@/core/types";

import { httpAuth } from "../utils/axios";

export const assessmentRequestsTyped = {
  get_definition: function ({
    assessmentId,
    params,
  }: {
    assessmentId: string;
    params?: ApiParams<{ version?: number }>;
  }): Promise<Assessment> {
    const config = {
      method: "GET",
      params,
      url: `/v1/assessment/get_definition/${assessmentId}`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<Assessment>;
  },

  post_answer: function ({
    data,
    params,
  }: {
    data: AssessmentSubmissionBody;
    params?: ApiParams;
  }): Promise<AssessmentSubmissionResponse> {
    const config = {
      data,
      method: "POST",
      params,
      url: `/v1/assessment/post_answer`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AssessmentSubmissionResponse>;
  },

  skip_task: function ({ taskId }: { taskId: Task["task_id"] }): Promise<void> {
    const config = {
      method: "POST",
      url: `/v1/assessment/skip_task/${taskId}`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<void>;
  },
};
